import PropTypes from 'prop-types';

const CategoryCard = ({ title, previewImage, url, target, ctaButtonText }) => (
  <a
    href={url}
    className="d-block image-hover position-relative gradient-overlay rounded overflow-hidden"
    target={target || '_self'}
  >
    <div className="experience-category-card__title gradient-overlay__content position-absolute">
      <h3
        className={`text-white fw-normal${
          ctaButtonText ? ' line-clamp-2' : ''
        }`}
        title={title}
      >
        {title}
      </h3>
      {ctaButtonText && (
        <div className="btn btn-primary common-card__button mt-2">
          {ctaButtonText}
        </div>
      )}
    </div>
    <img
      loading="lazy"
      src={previewImage.url}
      alt={previewImage.alt}
      width={previewImage.width}
      height={previewImage.height}
    />
  </a>
);

export default CategoryCard;

CategoryCard.propTypes = {
  title: PropTypes.string.isRequired,
  previewImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
  url: PropTypes.string.isRequired,
  target: PropTypes.string,
  ctaButtonText: PropTypes.string,
};
